exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ra-suggest{position:relative;display:inline-block;color:#55606e}.ra-suggest.show .ra-suggest-list{display:block}.ra-suggest .ra-suggest-list{display:none;position:absolute;margin:0;padding:0;list-style:none;background-color:#fff;z-index:9999;width:100%;box-sizing:border-box;overflow-y:auto}.ra-suggest .ra-suggest-list .ra-suggest-item{box-sizing:border-box;height:40px;line-height:20px;padding:10px 16px;font-size:12px;cursor:pointer}.ra-suggest .ra-suggest-list .ra-suggest-item.focus{background-color:#24afb2;color:#fff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader!./src/index.less
 ** module id = 8
 ** module chunks = 0
 **/